<template>

	<div class="container-fluid erco-header">
		<div class="row">
			<div class="col col-auto">
				<span class="icon">
					<a class="go-back" href="/#/dashboard">
						<b-button class="_btn" size="sm">
							&times;
							<!--
								<img src="../../assets/img/home.svg"></img>
							-->
						</b-button>
					</a>
				</span>
				<span class="name">{{ name }}</span>
				<span class="id">{{ id }}</span>
				<span class="bc">
					<span v-for="entry in breadcrumb.concat(name)" class="entry">{{ entry }}</span>
				</span>
			</div>
			<div class="col text-right">

				<b-button v-if="isVisitable"
						  size="sm"
						  href="#"
						  variant="info"
						  class="action-btn"
						  @click="handleClearCacheClick">
					Cache leeren
					<erco-tooltip v-if="clearCacheButtonTooltip && clearCacheButtonTooltip.text"
					              :variant="clearCacheButtonTooltip.variant"
					              :title="clearCacheButtonTooltip.title"
					              :text="clearCacheButtonTooltip.text"
					              :invertIcon="true"
					              offsetY="1rem">
					</erco-tooltip>
				</b-button>

				<b-button-group class="preview-block">
					<b-button size="sm"
							  href="#"
							  class="action-btn"
							  @click="handleRenewPreviewClick">
						<span v-if="isVisitable">
							Preview erneuern
							<erco-tooltip v-if="renewPreviewButtonTooltip && renewPreviewButtonTooltip.text"
							              :variant="renewPreviewButtonTooltip.variant"
							              :title="renewPreviewButtonTooltip.title"
							              :text="renewPreviewButtonTooltip.text"
							              :invertIcon="true"
							              offsetY="1rem">
						</erco-tooltip>
						</span>
						<span v-else>
							Preview erstellen
							<erco-tooltip v-if="createPreviewButtonTooltip && createPreviewButtonTooltip.text"
							              :variant="createPreviewButtonTooltip.variant"
							              :title="createPreviewButtonTooltip.title"
							              :text="createPreviewButtonTooltip.text"
							              :invertIcon="true"
							              offsetY="1rem">
						</erco-tooltip>
						</span>
					</b-button>

					<b-button v-if="isVisitable"
							  size="sm"
							  href="#"
							  @click="openSiteUrl">
						Ansehen
					</b-button>
				</b-button-group>

				<b-button v-if="isProductive && isVisitable"
				          size="sm"
				          href="#"
				          variant="success"
				          class="action-btn mr-4"
				          @click="handleRenewProductiveClickWithPreCheck">
					Online erneuern
					<erco-tooltip v-if="renewOnlineButtonTooltip && renewOnlineButtonTooltip.text"
					              :variant="renewOnlineButtonTooltip.variant"
					              :title="renewOnlineButtonTooltip.title"
					              :text="renewOnlineButtonTooltip.text"
					              :invertIcon="true"
					              offsetY="1rem">
					</erco-tooltip>
				</b-button>

			</div>
		</div>

		<b-modal id="action-confirmation"
		         ref="actionConfirmation"
		         class="action-confirmation-modal"
		         :title="actionConfirmationModalState.title"
		         closeTitle="Abbrechen"
		         @ok="actionConfirmationModalState.okfunc">
			<p class="_infotext">
				<span v-html="actionConfirmationModalState.text"></span>
			</p>
			<div class="selected-obj-list-container">
				<b-list-group class="selected-obj-list">
					<b-list-group-item class="_entry_">
						<span class="_title font-weight-bold">{{ name }}</span>
						<span class="_id float-left text-muted">{{ id }}</span>
						<span class="_badge">
							<erco-status-badge :status="statusname">
							</erco-status-badge>
						</span>
					</b-list-group-item>
				</b-list-group>
			</div>
		</b-modal>
	</div>

</template>

<script>
	import InfoText from '@/helper/infoTextHelper';

	import ErcoTooltip from '@/components/molecules/ErcoTooltip';
	import ErcoStatusBadge from '@/components/atoms/ErcoStatusBadge';

	export default {
		name: 'ErcoHeaderMolecule',

		props: {
			name: {
				type: String,
				default: '',
			},
			id: {
				type: String,
				default: '',
			},
			breadcrumb: {
				type: Array,
				default: [],
			},
			previewUrl: {
				type: String,
				default: '',
			},
			status: {
				type: Number,
				required: true,
			},
			stati: {
				type: Object,
				required: true,
			},
			isProductive: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				renewOnlineButtonTooltip: InfoText.for('header.renewOnlineButton'),
				renewPreviewButtonTooltip: InfoText.for('header.renewPreviewButton'),
				createPreviewButtonTooltip: InfoText.for('header.createPreviewButton'),
				clearCacheButtonTooltip: InfoText.for('header.clearCacheButton'),
			};
		},

		components: {
			ErcoTooltip,
			ErcoStatusBadge,
		},

		computed: {
			isVisitable() {
				/* Besitzt eine URL -> somit liegt auch HTML vor */
				return !!this.previewUrl;
			},
			statusname() {
				return Object.keys(this.stati).reduce((acc, statusKey) =>
					((this.stati[statusKey] === this.status) ? statusKey : acc), '');
			},
			actionConfirmationModalState() {
				const entries = {
					onlineRenew: {
						title: 'Online erneuern',

						text: 'Soll das Objekt wirklich online erneuert werden? Die Veröffentlichung kann bis zu 10 Minuten dauern.',
						okfunc: this.handleRenewProductiveClick,
					},
					default: {
						title: '',
						text: '',
						func: () => {},
					},
				};

				/* TODO: Evtl. Einträge ergänzen und hier die Auswahl treffen */
				return entries.onlineRenew;
			},
		},

		methods: {
			openSiteUrl() {
				window.open(this.previewUrl, '_blank');
			},

			handleRenewPreviewClick() {
				this.$store.dispatch('updateObjectSetupStatus', {
					status: this.stati.online,
					passLang: true,
					mode: 'preview',
				});
			},

			handleClearCacheClick() {
				this.$store.dispatch('clearLightscoutCacheEntry');
			},

			handleRenewProductiveClickWithPreCheck() {
				this.$refs.actionConfirmation.show();
			},

			handleRenewProductiveClick() {
				this.$store.dispatch('updateObjectSetupStatus', {
					status: this.stati.synchronize,
					passLang: true,
				});
			},
		},
	};
</script>


<style lang="scss">
	.erco-header {
		background-color: black;
		padding-top: 1rem;
		padding-bottom: 1rem;

		.icon {
			position: absolute;

			._btn {
				background-color: transparent;
				color: white;
			}
		}

		.name {
			margin-left: 3rem;
			color: white;
		}

		.id {
			color: rgba(255, 255, 255, 0.5);
			margin-left: 2rem;
		}

		.bc {
			margin-left: 2rem;
			font-size: 0.8rem;
			position: relative;
			color: white;

			&::before {
				// content: '';
				width: 7px;
				height: 7px;
				border: 2px solid white;
				border-bottom-width: 0;
				border-left-width: 0;
				transform: rotate(45deg);
				display: inline-block;
				margin-right: 0.6rem;
				vertical-align: middle;
			}

			> .entry {
				&:not(:first-child)::before {
					content: '/';
					margin: 0 0.5rem;
				}
			}
		}

		.action-btn {
			.erco-tooltip {
				margin-left: 0.2rem;
			}
		}

		.preview-block {
			.action-btn {
				background-color: rgb(211, 211, 211);

				&:hover {
					background-color: darken(rgb(211, 211, 211), 10%);
				}
			}
		}

		.action-confirmation-modal {
			.modal {
				display: block;
			}

			._infotext {
				margin: 0.5rem 0 2rem;
			}

			.selected-obj-list-container {
				max-height: 300px;
				overflow: auto;

				> .selected-obj-list {
					> ._entry_ {
						display: flex;

						._title {
							flex: 1;
						}

						._id {
							flex: 0;
							padding-right: 0.5rem;
						}

						._badge {
							width: 4rem;
							text-align: right;
						}

					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// ErcoHeader.vue?16513fe8